module.exports = __webpack_public_path__ + "static/6-a1b968229028a0abeed46be8d1f7fc4d.jpg";